import React, { useEffect, useState } from "react";
import Header from "../../../Components/HeaderAdmin/Header";
import { Form } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { ShippingStGetbyId, ShippingStUpdate } from "../../../Api/ShippingSt";
import { StagingStGetById, StagingStUpdate } from "../../../Api/StagingSt";

function ShipStationView() {
    const [pageStage, setPageStage] = useState("view");
    const [station_name, setStation_name] = useState('');
    const [stationId, setStationId] = useState('');
    const { id } = useParams();
    const [buildDta, setBuildDta] = useState({});

    useEffect(() => {
        getDataById();
    }, []);

    const getDataById = () => {
        StagingStGetById({ StagingSt_id: id })
            .then((res) => {
                if (res?.code === 200) {
                    const Data = res.data.data;
                    setBuildDta(Data);
                    setStation_name(Data.Staging_Stations_name);
                    setStationId(Data.Staging_Stations_id);
                } else {
                    alert(res.data?.message);
                }
            })
            .catch((err) => {
                alert("Error fetching data: " + err);
            });
    };

    const handleEditView = () => {
        setPageStage((prevStage) => (prevStage === "view" ? "edit" : "view"));
    };

    const handleEditbuildST = (e) => {
        e.preventDefault();
        const data = {
            Staging_Stations_name: station_name,
            Staging_Stations_id: stationId,
            StagingSt_id: id
        };
        StagingStUpdate(data)
            .then((res) => {
                if (res?.code === 200) {
                    const Data = res.data.data;
                    alert("Station details Updated successfully.");
                } else {
                    alert(res.data?.message);
                }
            })
            .catch((err) => {
                alert("Error updating data: " + err);
                console.error("Error:", err);
            });
    };

    return (
        <>
            <div className="main-page-body-content-header">
                <Header />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="sec-header-dash">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>Staging Station View</h3>
                                        </div>
                                        <div className="content-box-btn">
                                            <button className="btn btn-add" onClick={handleEditView}>{pageStage === "view" ? "Edit" : "View"}</button>
                                        </div>
                                    </div>
                                    <div className="dashboard-sec">
                                        <div className="container-fulid">
                                            <Form onSubmit={handleEditbuildST}>
                                                <fieldset disabled={pageStage === "view"}>
                                                    <div className="form-box-section mt-4">
                                                        <div className="form-box-inner">
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-6">
                                                                        <label className="dashboard-form-lable">Station ID</label>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Station ID"
                                                                        required
                                                                        className={`form-control dashboard-input-box-1 me-1 w-100`}
                                                                        value={stationId}
                                                                        onChange={(e) => setStationId(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group mb-0">
                                                                    <div className="col-md-6">
                                                                        <label className="dashboard-form-lable">Station Name</label>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Station Name"
                                                                        required
                                                                        className={`form-control dashboard-input-box-1 me-1`}
                                                                        value={station_name}
                                                                        onChange={(e) => setStation_name(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                <div className="sec-btn-group mt-4">
                                                    <div></div>
                                                    {pageStage === "edit" && (
                                                        <button className="btn btn-save" type="submit">Save</button>
                                                    )}
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ShipStationView;
